import axios from "axios";
import { Node } from "reactflow";
import { webURL } from "../../services/API";

// ---
export async function getGoogleAccountToken(params: { id: string, access_token: string, id_token: string, refresh_token: string }, nodeId?: string, setNodes?: (payload: Node<any>[] | ((nodes: Node<any>[]) => Node<any>[])) => void): Promise<string> {
   const data = (await axios.post(`${webURL}/general-extra/googleToken?type=checkExpired`, { id_token: params.id_token })).data;

   if (data.isExpired) {
      const data = (await axios.post(`${webURL}/general-extra/googleToken?type=refresh`, { refresh_token: params.refresh_token })).data;
      if (nodeId && setNodes) {
         setNodes((nodes) => nodes.map(node => {
            if (node.id === nodeId) return { ...node, data: { ...node.data, value: { ...node.data.value, connection: { ...node.data.value.connection, ...data }}}};
            else return node;
         }));
      }
      await axios.put(`${webURL}/connections?id=${params.id}`, data);
      return data.access_token;
   } else {
      return params.access_token;
   }
}

// ---
export async function getMicrosoftAccountToken(params: { id: string, accessToken: string, expiresOn: string, refresh_token: string }, nodeId?: string, setNodes?: (payload: Node<any>[] | ((nodes: Node<any>[]) => Node<any>[])) => void): Promise<string> {
   const data = (await axios.post(`${webURL}/general-extra/microsoftToken?type=checkExpired`, { expiresOn: params.expiresOn })).data;
   console.log(data);

   if (data.isExpired) {
      const data = (await axios.post(`${webURL}/general-extra/microsoftToken?type=refresh`, { refresh_token: params.refresh_token })).data;
      if (nodeId && setNodes) {
         setNodes((nodes) => nodes.map(node => {
            if (node.id === nodeId) return { ...node, data: { ...node.data, value: { ...node.data.value, connection: { ...node.data.value.connection, ...data }}}};
            else return node;
         }));
      }
      console.log(data);
      await axios.put(`${webURL}/connections?id=${params.id}`, data);
      return data.access_token;
   } else {
      return params.accessToken;
   }
}

// ---
export async function getJiraAccountToken(params: { id: string, access_token: string, refresh_token: string }, nodeId?: string, setNodes?: (payload: Node<any>[] | ((nodes: Node<any>[]) => Node<any>[])) => void): Promise<string> {
   const data = (await axios.post(`${webURL}/general-extra/jiraToken?type=checkExpired`, { accessToken: params.access_token })).data;

   if (data.isExpired) {
      const data = (await axios.post(`${webURL}/general-extra/jiraToken?type=refresh`, { refresh_token: params.refresh_token })).data;
      if (nodeId && setNodes) {
         setNodes((nodes) => nodes.map(node => {
            if (node.id === nodeId) return { ...node, data: { ...node.data, value: { ...node.data.value, connection: { ...node.data.value.connection, ...data }}}};
            else return node;
         }));
      }
      await axios.put(`${webURL}/connections?id=${params.id}`, data);
      return data.access_token;
   } else {
      return params.access_token;
   }
}